$(document).ready(function ($) {
  $('#contact_form').attr('novalidate', 'novalidate');

  $('.contact_form_care_page').on('submit',function(e){
    var that = $(this),
        f_name = that.find('input[name="contact[name][first]"]').val(),
        errorBox_f_name = that.find('input[name="contact[name][first]"]').parent().parent().parent().find('.error-box'),
        l_name = that.find('input[name="contact[name][last]"]').val(),
        errorBox_l_name = that.find('input[name="contact[name][last]"]').parent().parent().parent().find('.error-box'),
        email = that.find('input[name="contact[email]"]'),
        email_val = email.val(),
        errorBox_email = email.parent().parent().parent().find('.error-box.email'),
        phone_parent = that.find('.phone-wrapper'),
        phone = that.find('input[name="contact[phone]"]').val(),
        message = that.find('textarea[name="contact[body]"]'),
        errorBox_message = that.find('textarea[name="contact[body]"]').parent().parent().parent().find('.error-box.message'),
        error = false;
    if(f_name == ''){
      errorBox_f_name.show();
      error = true;
    }else{
      errorBox_f_name.hide();
    }


    if(l_name == ''){
      errorBox_l_name.show();
      error = true;
    }else{
      errorBox_l_name.hide();
    }


    if(phone_parent.hasClass('active') && phone == ''){
      error = true;
      phone_parent.find('.error-box').show();
    }else{
      phone_parent.find('.error-box').hide();
    }


    if(message.val() == ''){
      errorBox_message.show();
      error = true;
    }else{
      errorBox_message.hide();
    }

    
    if(email_val == ''){
      error = true;
      errorBox_email.text('Email Address is required.');
      errorBox_email.show();
    }else if (email_val.indexOf('@') === -1) {
         error = true;
       errorBox_email.text('Please include an \'@\' in the email addres. \''+email_val+'\' is missing an \'@\'');
       errorBox_email.show();
    } else if (!validateEmail(email_val)) {
       error = true;
       errorBox_email.text('Please enter valid email.');
       errorBox_email.show();
    } else {
       // hide error box
       errorBox_email.hide();
    }

    if(error){
      e.preventDefault();
    }





  });




 //  $('.contact_form_care_page').on('submit', function (e) {
 //      var that       = $(this),
	// 		emailField = that.find('input[type="email"]'),
	// 		$mc4wpResponse = that.find('.mc4wp-response'),
	// 		// errorBox   = form.find('.error-box');
	// 		errorBox   = emailField.parent().parent().find('.error-box');
	// 		if($mc4wpResponse.length > 0) {
	// 			$mc4wpResponse.remove();
	// 		}

 //    if (emailField.length && !emailField[0].validity.valid && emailField[0].validity.valueMissing) {
 //    	e.preventDefault();
	// 	// please fill field
	// 	errorBox.find('span').text('Please fill this field.');
	// 	errorBox.show();
 //    } else if (emailField.val().indexOf('@') === -1) {
 //    	e.preventDefault();
	// 	errorBox.find('span').text('Please include an \'@\' in the email addres. \''+emailField.val()+'\' is missing an \'@\'');
	// 	errorBox.show()
 //    } else if (!validateEmail(emailField.val())) {
 //    	e.preventDefault();
 //    	errorBox.find('span').text('Please enter valid email.');
	// 	errorBox.show();
	// } else {
 //    	// hide error box
 //    	errorBox.hide();
 //    }
 //  });

  // $('#contact_form_care_page').on('submit', function (e) {
  //   e.preventDefault();
  //   var that         = $(this);
  //     form           = $(this).closest('form'),
  //     emailField     = form.find('input[type="email"]'),
  //     $mc4wpResponse = form.find('.mc4wp-response'),
  //     errorBox       = emailField.parent().parent().find('.error-box'),
  //     requiredFileds = form.find('[required]'),
  //     error          = false;

  //     requiredFileds.each(function () {
  //       if ($(this).val() == '') {
  //         error = true;
  //         $(this).parent().find('.error-box').show();
  //       } else {
  //         $(this).parent().find('.error-box').show();
  //       }

  //     });
  //     console.log(error);
  // });

  $('.custom-page-cards .custom-page-card').click(function () {
  	var index = $(this).index('.custom-page-card');
    $('.custom-page-slider').trigger('to.owl.carousel', index);
  });

  $('.captcha').each(function () {
    console.log('captcha');
    new Captcha($(this).closest('form'), $(this).hasClass('api'));
    // new Captcha(jQuery('#form-contact-customer'));
  });
});

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function Captcha(form, api) {
  this.captchaData = null;
  this.form = form;
  this.captchaElClass = '.captcha';
  this.apiUrl = '/apps/peerless/captcha';
  var captchaValid = false;
  this.api = api

  this.loadCaptcha = function (reload) {
    $.ajax({
      type: 'get',
      url: this.apiUrl,
      dataType: 'json',
      success: function(response) {
        this.captchaData = response;
        this.addCaptchaImage(
          this.captchaData.img, 
          this.form.find(this.captchaElClass + ' .captcha-image-inner')
        );
        if (reload)
          this.form.find('.captcha-reload').removeClass('loading');
      }.bind(this)
    });
  }

  this.checkCaptcha = function () {
    var captchaInput = this.form.find('.captcha input');
    if (captchaInput.val().length < 5) {
      captchaInput.addClass('error');
      return;
    }
    captchaInput.removeClass('error');

    this.form.find('.captcha-input-load').addClass('loading');
    this.form.find('.captcha-input-success').removeClass('visible');
    this.form.find('.captcha-input-error').removeClass('visible');

    $.ajax({
      type: 'post',
      url: this.apiUrl,
      data: {
        captcha: captchaInput.val(),
        key: this.captchaData.key
      },
      dataType: 'json',
      success: function (resposnse) {
        console.log('captcha valid', resposnse);
        setTimeout(function () {
          if (resposnse.success) {
            this.form.find('.captcha-input-success').addClass('visible');
            captchaValid = true;
            if(this.api) this.form.addClass('form-valid');
            this.form.submit();

            this.resetCaptcha();
          } else this.form.find('.captcha-input-error').addClass('visible');
        }.bind(this), 500);

      }.bind(this),
      error: function() {
        this.form.find('.captcha-input-error').addClass('visible');
      }.bind(this),
      complete: function () {
        this.form.find('.captcha-input-load').removeClass('loading');
      }.bind(this)
    })
  }

  this.resetCaptcha = function () {
    setTimeout(function () {
      if(this.api) this.form.removeClass('form-valid');
      captchaValid = false;
      this.loadCaptcha(false);
      this.form.find('.captcha input').value = '';
    }.bind(this), 500);
  }
  
  this.addCaptchaBox = function (el) {
    var imageWrap = this.handleImageWrap();
    var captchaInputWrap = this.handleInputWrap();
    this.form.find(this.captchaElClass).append(imageWrap);
    this.form.find(this.captchaElClass).append(captchaInputWrap);
  }

  this.handleInputWrap = function () {
    var captchaInputWrap = this.createElement('div', { class: 'captcha-input-wrap' });
    var captchaInputError = this.createElement('div', { class: 'captcha-input-error' });
    var captchaInputSuccess = this.createElement('div', { class: 'captcha-input-success' });
    var captchaInputLoad = this.createElement('div', { class: 'captcha-input-load' });
    var loadingEl = this.createElement('i', { class: 'captcha-load icon-refresh icons' });
    captchaInputLoad.appendChild(loadingEl);

    var input = this.createElement('input', { type: 'text', id: 'captcha', placeholder: 'Type symbols here' });
    captchaInputWrap.appendChild(input);
    captchaInputWrap.appendChild(captchaInputLoad);
    captchaInputWrap.appendChild(captchaInputError);
    captchaInputWrap.appendChild(captchaInputSuccess);
    return captchaInputWrap;
  }

  this.handleImageWrap = function () {
    var wrap = this.createElement('div', { class: 'captcha-image-wrap' });
    var captchaInner = this.createElement('div', { class: 'captcha-image-inner' });
    var reloadElWrap = this.createElement('div', { class: 'captcha-reload-wrap' });
    var reloadEl = this.createElement('i', { class: 'captcha-reload icon-reload icons' });

    reloadElWrap.appendChild(reloadEl);
    wrap.appendChild(captchaInner)
    wrap.appendChild(reloadElWrap);
    return wrap;
  }

  this.addCaptchaImage = function (src, el) {
    el.html(this.createElement('img', { src: src}));
  }

  this.createElement = function (imgTag, options) {
    var element = document.createElement(imgTag);
    Object.keys(options).forEach(function (option) {
      element.setAttribute(option, options[option]);
    });
    return element;
  }

  this.initEvents = function () {
    this.form.find('.captcha-reload-wrap').on('click', function () {
      this.form.find('.captcha-reload').addClass('loading');
      this.loadCaptcha(true);
    }.bind(this));

    console.log('captchaValid', captchaValid);
    this.form.on('submit', function (e) {
      if (!captchaValid) {
        e.preventDefault();
        this.checkCaptcha();
      }
      
    }.bind(this));
  }

  this.init = function () {
    this.addCaptchaBox();
    this.initEvents();
    this.loadCaptcha(false);
  }

  this.init();
}